var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.082,
    height: 14.083,
    viewBox: "0 0 14.082 14.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.845,182.825l-1.659,1.659A1.76,1.76,0,0,1,.7,181.995l3.319-3.319a1.76,1.76,0,0,1,2.489,0,.587.587,0,0,0,.83-.83,2.933,2.933,0,0,0-4.149,0l-3.319,3.319a2.934,2.934,0,0,0,4.149,4.149l1.659-1.659a.587.587,0,1,0-.83-.83Z",
    transform: "translate(0.993 -172.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.907-.141a2.934,2.934,0,0,0-4.149,0L191.767,1.85a.587.587,0,0,0,.83.83L194.588.689a1.76,1.76,0,0,1,2.49,2.489l-3.651,3.651a1.76,1.76,0,0,1-2.489,0,.587.587,0,0,0-.83.83,2.933,2.933,0,0,0,4.149,0l3.651-3.651A2.933,2.933,0,0,0,197.907-.141Z",
    transform: "translate(-184.684 1)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLink);
export default __webpack_public_path__ + "static/media/ico-link.e2affbd4c7635b2969b722fbd5b5cd2e.svg";
export { ForwardRef as ReactComponent };